import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { Box } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const languageMap = {
  en: { label: "EN", dir: "ltr", active: true },
  tr: { label: "TR", dir: "ltr", active: false },
};

const LanguageSelect = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const selected = i18n.language;
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  React.useEffect(() => {
    document.body.dir = languageMap[selected]?.dir;
  }, [menuAnchor, selected]);
  return (
    <Box>
      <div>
        <List component="nav" aria-label="Language settings">
          <ListItem
            button
            aria-haspopup="listbox"
            aria-controls="language-menu"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickListItem}
          >
            <ListItemText primary={languageMap[i18n.language]?.label} />
          </ListItem>
        </List>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "lock-button",
            role: "listbox",
          }}
        >
          <MenuItem disabled>{t("select_language")}</MenuItem>
          {Object.keys(languageMap).map((option, index) => (
            <MenuItem
              key={option}
              selected={option === i18n.language}
              onClick={() => {
                i18n.changeLanguage(option);
                navigate(0);
                setMenuAnchor(null);
              }}
            >
              {languageMap[option].label}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </Box>
  );
};

export default LanguageSelect;
